import { render, staticRenderFns } from "./NursingStatsDashboard.vue?vue&type=template&id=19945c0c&scoped=true"
import script from "./NursingStatsDashboard.vue?vue&type=script&lang=js"
export * from "./NursingStatsDashboard.vue?vue&type=script&lang=js"
import style0 from "./NursingStatsDashboard.vue?vue&type=style&index=0&id=19945c0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19945c0c",
  null
  
)

export default component.exports